module.exports = __webpack_public_path__ + "img/icon-message-question.f9b691f8.svg";